import { API_VERSION } from '@trip-ux/constants';

export const LOAD_CONFIG = 'LOAD_CONFIG';
export const SET_ORGANIZATION_CODE = 'SET_ORGANIZATION_CODE';
export const SET_SELLING_CODE = 'SET_SELLING_CODE';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_TRANSLATION_DATE_FORMAT = 'SET_TRANSLATION_DATE_FORMAT';
export const SET_LOCALE = 'SET_LOCALE';

export const SALES_CHANNEL = {
  B2B: 'b2b',
  B2C: 'b2c'
};

export type ApiVersion = `${API_VERSION}`;

export interface ConfigState {
  locale?: string;
  isAdmin?: boolean;
  staticSubMenuNavId?: string;
  bannerId?: string;
  options?: {
    translation: string;
    translationConfig: string;
    translationSpace: string;
    salesChannel: string;
    contextPath: string;
    clientContextPath: Record<string, string>;
    aemRegex: string;
    paymentIframe: string;
    manulifeId: string;
    preferencesEN: string;
    preferencesFR: string;
    monerisProfileId: string;
    organizationCode: string;
    reportConfig: any;
    advisorReportConfig: any;
    commissionOverrideReportConfig: any;
    debounceInterval: number;
    apiVersion: ApiVersion;
  };
  pageTitle?: string;
  previousDateFormat?: string;
  currentDateFormat?: string;
}
